export default "__VITE_ASSET__BKSuvb3C__"